import styles from "../LightHouse.module.css"
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SideNav from "./SideNav";

function HeaderMain({ variant, menuList }) {
    const [rightNav, setRightNav] = useState(false);
    const outside = useRef();
    const navigate = useNavigate();


    const handleBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        const handlePopState = () => {
            setRightNav(prev => {
                if (prev === true) {
                    return false;
                }
                return prev;
            });
        };

        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, []);


    const handleRightNavToggle = () => {
        setRightNav(prev => {
            if (prev === false) {
                window.history.pushState(null, "");
                return true;
            } else {
                window.history.back();
                return prev;
            }
        });
    };

    useEffect(() => {
        if (rightNav) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [rightNav]);

    if (variant == "mainHeader") {
        return (
            <div className='header'>
                <div className='header_inner'>
                    <button type="button" className='nav_btn' onClick={handleRightNavToggle}>
                        <img src={process.env.PUBLIC_URL + '/lightHouseImg/nav.png'} alt='네비게이션' />
                    </button>
                    <SideNav rightNav={rightNav} outside={outside} setRightNav={setRightNav} menuList={menuList}></SideNav>
                </div>
            </div>
        )
    }

    if (variant === "subHeader") {
        return (
            <div className={`header subHeader ${styles.header_lightHouse}`}>
                <div className='header_inner'>
                    <button type="button" className={`goBack ${styles.goBack_lightHouse}`} onClick={(() => { handleBack() })}>
                        <img src={process.env.PUBLIC_URL + '/lightHouseImg/goBack.png'} alt='뒤로가기' />
                    </button>
                    <SideNav rightNav={rightNav} outside={outside} setRightNav={setRightNav} menuList={menuList}></SideNav>
                </div>
            </div>
        );
    }

    if (variant === "backHeader") {
        return (
            <div className={`header subHeader ${styles.header_lightHouse}`}>
                <div className='header_inner'>
                    <button type="button" className={`goBack ${styles.goBack_lightHouse}`} onClick={(() => { handleBack() })}>
                        <img src={process.env.PUBLIC_URL + '/lightHouseImg/goBack.png'} alt='뒤로가기' />
                    </button>
                    <Link to="/lightHouse" className="headerLogo">
                        <img src={process.env.PUBLIC_URL + '/image/lightHouse_logo.png'} alt='별별운세' />
                    </Link>
                    <button type="button" className='nav_btn'onClick={handleRightNavToggle}>
                        <img src={process.env.PUBLIC_URL + '/lightHouseImg/nav.png'} alt='네비게이션' />
                    </button>
                    <SideNav rightNav={rightNav} outside={outside} setRightNav={setRightNav} menuList={menuList}></SideNav>
                </div>
            </div>
        );
    }

    if (variant === "backHeaderOnly") {
        return (
            <div className={`header subHeader ${styles.header_lightHouse}`}>
                <div className='header_inner'>
                    <button type="button" className={`goBack ${styles.goBack_lightHouse}`} onClick={(() => { handleBack() })}>
                        <img src={process.env.PUBLIC_URL + '/lightHouseImg/goBack.png'} alt='뒤로가기' />
                    </button>
                    <Link to="/lightHouse" className="headerLogo">
                        <img src={process.env.PUBLIC_URL + '/image/lightHouse_logo.png'} alt='별별운세' />
                    </Link>
                </div>
            </div>
        );
    }
}

export default HeaderMain;